export default __webpack_public_path__ + "static/media/aboutimg.1e30b261.jpg";